import { createAction } from '@reduxjs/toolkit';

export const reportError = createAction('errors/report');
